module.exports = __webpack_public_path__ + "static/assets/d62911617eac1bd4197ec7afbc9249c3.gif";